import * as React from 'react';
import { type Theme, useStyletron } from 'baseui';
const HEX_REGEX = /^#[0-9a-fA-F]{6}$/;
type HexColorInputPropsT = {
  value: string;
  fallbackColor: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
};
const getRowStyles = (theme: Theme) => ({
  display: ('flex' as const),
  alignItems: ('center' as const),
  gap: theme.sizing.scale300,
  marginTop: theme.sizing.scale200
});
const getPreviewStyles = (color: string, theme: Theme) => ({
  width: theme.sizing.scale700,
  height: theme.sizing.scale700,
  borderRadius: theme.borders.radius200,
  backgroundColor: color,
  flexShrink: 0
});
const getInputStyles = (theme: Theme) => ({
  ...theme.typography.ParagraphSmall,
  flex: 1,
  padding: `${theme.sizing.scale200} ${theme.sizing.scale300}`,
  border: `1px solid ${theme.colors.borderOpaque}`,
  borderRadius: theme.borders.radius200,
  outline: 'none',
  backgroundColor: theme.colors.backgroundSecondary,
  color: theme.colors.contentPrimary
});
export function HexColorInput({
  value,
  fallbackColor,
  onChange,
  onSubmit
}: HexColorInputPropsT) {
  const [css, theme] = useStyletron();
  const previewColor = HEX_REGEX.test(value) ? value : fallbackColor;
  return <div className={css(getRowStyles(theme))}>
      <div className={css(getPreviewStyles(previewColor, theme))} />
      <input className={css(getInputStyles(theme))} value={value} onChange={e => onChange(e.target.value)} onKeyDown={e => {
      if (e.key === 'Enter') onSubmit();
    }} placeholder="#000000" data-testid="color-hex-input" />
    </div>;
}